export const SYSTEM_COLORS = {
  primary: "#11cdef",
  primaryDark: "#0747a6",
  success: "#2dce89",
  danger: "#f5365c",
  warning: "#fb6340",
  info: "#11cdef",
  secondary: "#6c757d",
  dark: "#1e293b",
  light: "#f8f9fa",
  muted: "#64748b",
  white: "#ffffff",

  tableStickyBg: "#ecf3fb",
  tableStickyBorder: "#dae9fb",
  tableHeaderBg: "#f8f9fa",
  tableBorder: "#ebedf0",

  borderOpacity: "33",
};

export const STATUS_THEMES = {
  SUCCESS: {
    color: SYSTEM_COLORS.success,
    bg: "#e8f5e9",
    icon: "check_circle",
  },
  DANGER: { color: SYSTEM_COLORS.danger, bg: "#fff5f5", icon: "cancel" },
  WARNING: {
    color: SYSTEM_COLORS.warning,
    bg: "#fffaf0",
    icon: "error_outline",
  },
  INFO: { color: SYSTEM_COLORS.info, bg: "#e3f2fd", icon: "event" },
  SECONDARY: {
    color: SYSTEM_COLORS.secondary,
    bg: "#f8f9fa",
    icon: "help_outline",
  },
};

export const BADGE_STYLES = {
  danger: { color: "#b91c1c", bg: "#fee2e2" },
  success: { color: "#15803d", bg: "#dcfce7" },
  neutral: { color: "#1e293b", bg: "#f1f5f9" },
  dummy: { color: "#94a3b8", bg: "#f1f5f9" },
};

export const commonFlexStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
